export async function fetchTeamData(team_number, year, signal) {
  console.log("getting");
  const url = `https://api.statbotics.io/v3/team_year/${team_number}/${year}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    console.log("done");
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Fetch request was aborted");
    } else {
      console.error("Error fetching team data:", error);
    }
    return null;
  }
}

export async function fetchEventTeamData(team_number, event, signal) {
  console.log("getting");
  const url = `https://api.statbotics.io/v3/team_event/${team_number}/${event}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    console.log("done");
    return await response.json();
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Fetch request was aborted");
    } else {
      console.error("Error fetching team data:", error);
    }
    return null;
  }
}
